import { Controller } from "@hotwired/stimulus"

// Reloads the current page once a form inside the shared `modal` turbo frame
// has been saved and the modal has finished closing. For list pages (e.g.
// Time Dashboard exceptions) whose rows open the timesheet edit modal: the
// update response only streams targets from the timesheets index, so without
// this the resolved row would sit on screen until a manual refresh.
//
// The timesheet controller answers a failed validation with a 200 that
// re-renders the frame, so `turbo:submit-end` reports success either way.
// The modal element that was open at submit time is remembered instead: a
// successful save closes that same element, while a re-render swaps in a new
// one, so closing the error modal later never triggers a reload.
//
// Usage (both actions are required):
//   <div data-controller="refresh-after-modal-save"
//        data-action="turbo:submit-end@document->refresh-after-modal-save#submitted
//                     hidden.bs.modal@document->refresh-after-modal-save#refresh">
export default class extends Controller {
  connect() {
    this.savedModal = null
  }

  submitted(event) {
    if (!event.detail?.success) return

    const frame = event.target.closest('turbo-frame#modal')
    if (!frame) return

    this.savedModal = frame.querySelector('.modal')
  }

  refresh(event) {
    const saved = this.savedModal
    if (!saved) return

    this.savedModal = null
    if (event.target !== saved) return

    Turbo.visit(window.location.href, { action: "replace" })
  }
}
